import { render, staticRenderFns } from "./PopupTable.vue?vue&type=template&id=74b15c46&"
import script from "./PopupTable.vue?vue&type=script&lang=js&"
export * from "./PopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports